import { useSelector } from 'react-redux'

import {
    ClockCircleOutlined,
    DownloadOutlined,
    FileOutlined,
    PaperClipOutlined,
} from '@ant-design/icons'
import { Button, Card, Image, Space, Timeline, Tooltip } from 'antd'

import {
    fDateTime,
    isValidArray,
} from '../../../../../../../sprints/components/testReport/testCases/forms/helper'
import { testRunState } from '../../../../../../redux/testRun/testRunList.slice'
import SkeletonCommentHistory from './SkeletonCommentHistory'

function isImage(url) {
    return /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(url)
}

const CommentList = () => {
    // SELECTORS

    const {
        testRunTestCaseDetailLoading = false,
        testRunTestCaseDetail: testCaseDetailData = {},
    } = useSelector(testRunState)

    const { comments = [] } = testCaseDetailData

    const items = (comments || []).map((c) => ({
        dot: <ClockCircleOutlined style={{ fontSize: 14 }} />,
        children: (
            <Card
                key={c._id}
                size="small"
                styles={{ body: { padding: 12 }, marginTop: 5 }}
                bordered
            >
                <Space direction="vertical" size={6} style={{ width: '100%' }}>
                    <Space
                        align="center"
                        style={{
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <h5 strong>Comment</h5>
                        <Tooltip title={fDateTime(c.date)}>
                            <p type="secondary" style={{ fontSize: 12 }}>
                                {fDateTime(c.date)}
                            </p>
                        </Tooltip>
                    </Space>

                    <p style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                        {c.description}
                    </p>

                    <AttachmentList attachments={c.attachments || []} />
                </Space>
            </Card>
        ),
    }))

    if (testRunTestCaseDetailLoading) {
        return <SkeletonCommentHistory />
    }

    if (!testRunTestCaseDetailLoading) {
        return (
            <Card
                title={'Comment History'}
                bordered={false}
                styles={{ body: { paddingTop: 8 } }}
            >
                {isValidArray(items) && (
                    <Timeline
                        mode="left"
                        items={items}
                        style={{ marginLeft: 8, marginTop: 8 }}
                    />
                )}
                {!isValidArray(items) && (
                    <div style={{ textAlign: 'center', padding: 4 }}>
                        {' '}
                        <p>No Comments Found.</p>
                    </div>
                )}
            </Card>
        )
    }
}

export default CommentList

function AttachmentList({ attachments = [] }) {
    if (!attachments.length) return null

    return (
        <Space direction="vertical" size={8} style={{ marginTop: 8 }}>
            <Space align="center">
                <PaperClipOutlined />
                <p>Attachments ({attachments.length})</p>
            </Space>

            <Space wrap size={8}>
                {attachments.map((att) =>
                    isImage(att.url) ? (
                        <Image
                            key={att._id}
                            src={att.url}
                            width={96}
                            height={72}
                            style={{
                                objectFit: 'cover',
                                borderRadius: 8,
                                border: '1px solid #f0f0f0',
                            }}
                            placeholder
                        />
                    ) : (
                        <Space key={att._id} align="center">
                            {/* <FileOutlined /> */}
                            <Button
                                size="small"
                                title="Download Attachment"
                                type="link"
                                href={att.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                // icon={<DownloadOutlined />}
                                icon={<FileOutlined />}
                                style={{ border: '1px solid #f0f0f0' }}
                            >
                                {att?.fileName || 'Attachment'}
                            </Button>
                        </Space>
                    )
                )}
            </Space>
        </Space>
    )
}
